import { ArrowUpRight, AudioLines, LoaderCircle } from 'lucide-react'
import { Head, Link } from 'arcway/lib/client'

import { Logo } from '#components/logo.jsx'
import { SkipLink } from '#components/skip-link.jsx'

const stories = {
  login: ['Back to what', 'you do best.'],
  signup: ['An idea. A voice.', 'A place to begin.'],
  reset: ['Find your way', 'back to the mic.'],
  verify: ['A little check.', 'Then back to making.'],
  invite: ['Good shows bring', 'people together.'],
}

function VoiceIllustration() {
  return (
    <div className='auth-art' aria-hidden='true'>
      <svg viewBox='0 0 400 300' fill='none'>
        <circle cx='200' cy='150' r='130' fill='#dce991' />
        <circle cx='200' cy='150' r='111' stroke='#b1c16e' />
        <circle cx='200' cy='150' r='92' stroke='#b1c16e' />
        <path
          d='M45 160H65M75 140V180M86 127V193M97 144V176M108 135V185M119 149V171M130 141V179'
          stroke='#53623b'
          strokeWidth='5'
          strokeLinecap='round'
        />
        <path
          d='M270 145V175M281 130V190M292 144V176M303 121V199M314 139V181M325 150V170H347'
          stroke='#53623b'
          strokeWidth='5'
          strokeLinecap='round'
        />
        <g transform='rotate(-10 200 150)'>
          <rect x='170' y='72' width='60' height='119' rx='30' fill='#303a2b' />
          <path
            d='M188 89V129M200 83V129M212 89V129'
            stroke='#eaf0cc'
            strokeWidth='4'
            strokeLinecap='round'
          />
          <path
            d='M154 151V163C154 190 174 209 200 209C226 209 246 190 246 163V151M200 209V234M178 234H222'
            stroke='#303a2b'
            strokeWidth='6'
            strokeLinecap='round'
          />
        </g>
        <circle cx='314' cy='70' r='27' fill='#edb496' />
        <path d='M306 63L324 71L306 80V63Z' fill='#303a2b' />
      </svg>
      <span className='auth-art-note'>
        <AudioLines /> Made to be heard.
      </span>
    </div>
  )
}

export function AuthPageShell({
  children,
  description,
  kind = 'login',
  loading,
  title,
}) {
  const story = stories[kind] || stories.login
  return (
    <div className={`auth-workspace auth-kind-${kind}`}>
      {process.env.NODE_ENV === 'development' && (
        <Head>
          <link rel='stylesheet' href='/pages/_styles.css?direct' />
        </Head>
      )}
      <SkipLink />
      <header className='auth-header'>
        <Link aria-label='Mono home' href='/'>
          <Logo />
        </Link>
        <Link className='auth-home-link' href='/'>
          Back to Mono <ArrowUpRight aria-hidden='true' />
        </Link>
      </header>
      <main className='auth-layout' id='main-content' tabIndex='-1'>
        <aside className='auth-story' aria-labelledby='auth-story-title'>
          <p className='auth-eyebrow'>FOR THE LOVE OF MAKING SOMETHING.</p>
          <h2 id='auth-story-title'>
            {story[0]}
            <br />
            <em>{story[1]}</em>
          </h2>
          <VoiceIllustration />
          <p className='auth-story-caption'>
            Your voice. Your show. Your next chapter.
          </p>
        </aside>
        <section className='auth-form-panel' aria-labelledby='auth-title'>
          <div className='auth-form-content'>
            <div className='auth-form-heading'>
              <h1 id='auth-title'>{title}</h1>
              <p>{description}</p>
            </div>
            <div className='auth-form-body' aria-busy={loading || undefined}>
              {loading ? (
                <div className='auth-session-status' role='status'>
                  <LoaderCircle
                    aria-hidden='true'
                    className='size-6 animate-spin motion-reduce:animate-none'
                  />
                  <span>Checking your session…</span>
                </div>
              ) : (
                children
              )}
            </div>
          </div>
          <footer className='auth-footer'>
            <a href='mailto:support@mono.fm'>Need a hand?</a>
            <nav aria-label='Legal'>
              <Link href='/legal/privacy'>Privacy</Link>
              <Link href='/legal/terms'>Terms</Link>
            </nav>
          </footer>
        </section>
      </main>
    </div>
  )
}
